import { createAction, props } from "@ngrx/store";
import { Module } from "src/app/settings/models/module.model";

export const setModules = createAction('[MODULE] Set modules', props<{modules: Module[]}>());
export const setModuleDetail = createAction('[MODULE] Set module detail', props<{id: number}>());
export const setModuleForEdit = createAction('[MODULE] Set modules for edit', props<{moduleForEdit: Module}>());
export const setModuleForEditQR = createAction('[MODULE] Set modules for edit QR', props<{moduleForEdit: Module}>());
export const clearModuleForEdit = createAction('[MODULE] Clear modules for edit');